export const META_PIXEL_ID = '1114242334435971'

const CONTENT_PARAMS = {
  content_name: 'Megapack Maestro de Sesiones',
  content_type: 'product',
}

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
    __mdsPixelInitialized?: boolean
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

/**
 * Carga el Meta Pixel oficial una sola vez y dispara PageView + ViewContent.
 * El guard global evita una segunda instancia o eventos duplicados
 * (re-montajes, StrictMode, recargas en caliente).
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.__mdsPixelInitialized) return
  window.__mdsPixelInitialized = true

  if (!window.fbq) {
    const fbq: FbqFunction = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = SCRIPT_SRC
    const first = document.getElementsByTagName('script')[0]
    if (first?.parentNode) first.parentNode.insertBefore(script, first)
    else document.head.appendChild(script)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', CONTENT_PARAMS)
}

let checkoutInFlight = false

/**
 * Dispara InitiateCheckout y luego continúa al checkout.
 * Un lock evita duplicados por doble clic mientras se navega.
 */
export function trackInitiateCheckout(href: string): void {
  if (typeof window === 'undefined') return
  if (checkoutInFlight) return
  checkoutInFlight = true

  window.fbq?.('track', 'InitiateCheckout', CONTENT_PARAMS)

  // Pequeña espera para que el evento se envíe antes de salir de la página.
  window.setTimeout(() => {
    window.location.href = href
    window.setTimeout(() => {
      checkoutInFlight = false
    }, 1500)
  }, 250)
}
